const serverUrl = 'https://api.tecnoeste.net';
// const serverUrl = 'http://192.168.0.162:21124';
// const serverUrl = 'http://localhost:21124';

export default serverUrl;
